import clsx from "clsx";
import { NavLink, useLocation } from "react-router-dom";
import type { BreadcrumbData } from "use-react-router-breadcrumbs";

import styles from "./Breadcrumbs.module.scss";

type BreadcrumbsProps = {
  breadcrumbs?: BreadcrumbData[];
  fakeBreadcrumbs?: { title: string; link: string }[];
};

const Breadcrumbs = ({ breadcrumbs, fakeBreadcrumbs }: BreadcrumbsProps) => {
  const { pathname } = useLocation();

  return (
    // @ts-expect-error TS2339 non-existing className
    <div className={styles.breadcrumbs}>
      {breadcrumbs?.length &&
        breadcrumbs?.map(({ match, breadcrumb }) => (
          <NavLink
            key={match.pathname}
            to={match.pathname}
            className={clsx(styles.breadcrumbsLink, {
              [styles.breadcrumbsActive]: pathname === match.pathname,
            })}
          >
            {breadcrumb as React.ReactNode}
          </NavLink>
        ))}
      {fakeBreadcrumbs?.length &&
        fakeBreadcrumbs.map(({ title, link }) => (
          <NavLink
            key={title}
            to={link}
            className={clsx(styles.breadcrumbsLink, {
              [styles.breadcrumbsActive]: pathname === link,
            })}
          >
            {title}
          </NavLink>
        ))}
    </div>
  );
};
export default Breadcrumbs;
